import PageContent from "./PageContent";
import PageBox from "./PageBox";

export default {
  PageContent,
  PageBox,
};
